import { createMutationHook, createDCHook, collapseDataFromCall, collapseParams } from '../../client';
import { postV1SalesPublicOfferProducts, getProductTariffs } from '../../services/sales/AcquisitionService';

export const useAcquisitionPostV1SalesPublicOfferProducts = createMutationHook(postV1SalesPublicOfferProducts, {
  injectables: ['label', 'businessUnit'],
  flattenData: false,
});

// `product-tariffs` is a POST that behaves as a read, so it is wired up as a `createDCHook` (SWR) instead of the
// mutation hook the generator would emit for a POST. The rest follows the generated conventions: the envelope is
// collapsed away on both the request and the response, and label/businessUnit are injected.
export const useAcquisitionGetProductTariffs = createDCHook(
  'getProductTariffs',
  collapseDataFromCall(collapseParams(collapseParams(getProductTariffs, 'requestBody', 'data'), 'data', 'products')),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
  },
);
